import { Menu } from "../components/Menu";
import Footer from "../components/Footer";


const Struct = ({children, hide_menu = false}) => {
    return (
        <>
            <div className="flex flex-col items-center min-h-screen pt-14 h-full">
                <div className="w-full h-full flex-1 p-4 max-w-screen-xl ">
                    {children}  
                </div>
 
                {!hide_menu && (
                    <>
                        <Menu />
                        <Footer /> 
                    </>
                )}
         
            </div>

           
        </>
    )
}

export default Struct;